import { Absence } from "../Absence/Absence.type";
import { Allowance } from "../Allowance/Allowance.type";
import { Department } from "../Department/Department.type";
import { Document } from "../Document/Document.type";
import { ManpowerOvertime } from "../ManpowerOvertime/ManpowerOvertime.type";
import { ProjectStaff } from "../ProjectStaff/ProjectStaff.type";
import { ProjectTeam } from "../ProjectTeam/ProjectTeam.type";
import { Signature, User } from "../User/User.type";
import { ApiCallState } from "../Utils";

export type Staff = {
  id: any;
  user_id: number;
  document_id: number;
  government_id: number;
  department_id: number;
  signature_id: number;
  manager_id: number;
  coach_id: number;
  immediate_substitute_id: number;
  user: User;
  name: string;
  sex: string;
  description: string;
  salary: number;
  salary_type?: string;
  field_allowance: number;
  status: string;
  type: string;
  woreda: string;
  kebele: string;
  email: string;
  personal_email: string;
  city: string;
  sub_city: string;
  house_number: string;
  termination_date: Date;
  date: string;
  key: number;

  phone_number: string;
  period: string;
  createdAt: string;

  id_number: string;
  unique_uuid: string;
  tin_number: string;
  fund_type: string;
  bank_account: string;
  work_location: string;

  photo: Document;
  governmentId: Document;

  department: Department | null;
  projects: { name: string; id: number; project_staff: ProjectStaff }[] | null;
  equipment_wo_staff: { task: string };
  allowances: Allowance[];
  manpower_overtimes: ManpowerOvertime[];
  emergency_contact: EmergencyContact;
  employee_histories: EmployeeHistory[];
  employee_requests: {
    request_type: string;
    date: string;
    leave_request: {
      paid: number;
      unpaid: number;
      type: string;
      description: string;
      start_date: string;
      end_date: string;
      leave_finance: string;
    } | null;
    loan_request: {
      repayment_type: string;
      repayment_amount: number;
      amount: number;
      paid: number;
      reason: string;
    } | null;
    overtime_request: {
      description: string;
      date: string;
      overtime_start: string;
      overtime_end: string;
    } | null;
    travel_request: null;
    benefit_request: {
      type: string;
      description: string;
      amount: number;
    } | null;
  }[];
  absences: Absence[];

  signature: Signature;
  manager: Staff;
  coach: Staff;
  immediate_substitute: Staff;
  staff_id: StaffId;

  photo_url: string;

  project_teams: ProjectTeam[];
};

export type EmergencyContact = {
  id: number;
  government_id: number;
  guarantor_id: number;
  name: string;
  phone_number: string;
  house_number: string;
  woreda: string;
  kebele: string;
  city: string;
  sub_city: string;
  relation: string;
  collateral: string;
  government: Document;
  guarantor: Document;
};

export type EmployeeHistory = {
  id: number;
  staff_id: number;
  department_id: number;
  salary: number;
  allowance: number;
  overtime_salary: number;
  type: string;
  change: string;
  date: string;
  createdAt: "2021-04-21T15:02:37.000Z";
  updatedAt: "2021-04-21T15:02:37.000Z";
};

export type TempEmploymentWitness = {
  id: number;
  staff_id: number;
  signature_id: number;
  name: string;

  signature: Signature;
};

export type EmployeeGuarantorWitness = {
  id: number;
  staff_id: number;
  signature_id: number;
  name: string;

  signature: Signature;
};

export type StaffId = {
  id: number;
  user_id: number;
  staff_id: number;

  name_english: string;
  name_amharic: string;

  position_english: string;
  position_amharic: string;

  address_english: string;
  address_amharic: string;

  readonly createdAt: Date;
  readonly updatedAt: Date;
};

export type StaffStateTypes = {
  fetchAll: ApiCallState<Staff[]>;
  fetchOne: ApiCallState<Staff | null>;
  fetchAllDetail: ApiCallState<Staff[]>;
  fetchAllAlongTermination: ApiCallState<Staff[]>;
};

export const StaffActionTypes = {
  FETCH_ALL_STAFF: "FETCH_ALL_STAFF",
  FETCH_ALL_STAFF_RESET: "FETCH_ALL_STAFF_RESET",
  FETCH_ALL_STAFF_FAILURE: "FETCH_ALL_STAFF_FAILURE",
  FETCH_ALL_STAFF_SUCCESS: "FETCH_ALL_STAFF_SUCCESS",

  FETCH_ALL_STAFF_ALONG_TERMINATION: "FETCH_ALL_STAFF_ALONG_TERMINATION",
  FETCH_ALL_STAFF_ALONG_TERMINATION_RESET:
    "FETCH_ALL_STAFF_ALONG_TERMINATION_RESET",
  FETCH_ALL_STAFF_ALONG_TERMINATION_FAILURE:
    "FETCH_ALL_STAFF_ALONG_TERMINATION_FAILURE",
  FETCH_ALL_STAFF_ALONG_TERMINATION_SUCCESS:
    "FETCH_ALL_STAFF_ALONG_TERMINATION_SUCCESS",

  FETCH_ALL_DETAIL_STAFF: "FETCH_ALL_DETAIL_STAFF",
  FETCH_ALL_STAFF_DETAIL_RESET: "FETCH_ALL_STAFF_DETAIL_RESET",
  FETCH_ALL_STAFF_DETAIL_FAILURE: "FETCH_ALL_STAFF_DETAIL_FAILURE",
  FETCH_ALL_STAFF_DETAIL_SUCCESS: "FETCH_ALL_STAFF_DETAIL_SUCCESS",

  FETCH_ONE_STAFF: "FETCH_ONE_STAFF",
  FETCH_ONE_STAFF_RESET: "FETCH_ONE_STAFF_RESET",
  FETCH_ONE_STAFF_FAILURE: "FETCH_ONE_STAFF_FAILURE",
  FETCH_ONE_STAFF_SUCCESS: "FETCH_ONE_STAFF_SUCCESS",
};
